import { BaseRequest, IBaseRequest } from "../../BaseRequest";

export interface ICreateMessageContainerNotificationRequest extends IBaseRequest {
  ROW: MessageContainerNotificationRow;
}

export interface MessageContainerNotificationRow {
  id?: string;
  created?: string;
  createdBy?: string;
  modified?: string;
  modifiedBy?: string;
  MessageRecipient?: string;
  LastNotifiedMessageId?: string;
  MessageContainerName?: string;
  MessageContainerPath?: string;
  MessageContainerGroup?: string;
  MessageContainer?: string;
  MessageContainerCount?: string;
}

export class CreateMessageContainerNotificationRequest
  extends BaseRequest
  implements ICreateMessageContainerNotificationRequest
{
  public ROW: MessageContainerNotificationRow;

  constructor(
    server: string,
    session: string,
    row: MessageContainerNotificationRow,
  ) {
    super(server, session);
    this.ROW = row;
  }

  public toXml(): string {
    let parameters = super.toXml();

    parameters += `<ROW>`;
    parameters += this.makeNode(this.ROW.id, "id");
    parameters += this.makeNode(this.ROW.created, "created");
    parameters += this.makeNode(this.ROW.createdBy, "createdBy");
    parameters += this.makeNode(this.ROW.modified, "modified");
    parameters += this.makeNode(this.ROW.modifiedBy, "modifiedBy");
    parameters += this.makeNode(this.ROW.MessageRecipient, "MessageRecipient");
    parameters += this.makeNode(
      this.ROW.LastNotifiedMessageId,
      "LastNotifiedMessageId",
    );
    parameters += this.makeNode(
      this.ROW.MessageContainerName,
      "MessageContainerName",
    );
    parameters += this.makeNode(
      this.ROW.MessageContainerPath,
      "MessageContainerPath",
    );
    parameters += this.makeNode(
      this.ROW.MessageContainerGroup,
      "MessageContainerGroup",
    );
    parameters += this.makeNode(
      this.ROW.MessageContainer,
      "MessageContainer",
    );
    parameters += this.makeNode(
      this.ROW.MessageContainerCount,
      "MessageContainerCount",
    );
    parameters += `</ROW>`;

    return super.wrapperXml("CreateMessageContainerNotification", parameters);
  }
}

